import React, { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { clearSearch, searchRestaurants } from "../../../services/searchRestaurants/actions";
import Footer from "../Footer";
import ItemSearchList from "./ItemSearchList";
import Meta from "../../helpers/meta";
import RestaurantSearch from "./RestaurantSearch";
import RestaurantSearchList from "./RestaurantSearchList";
import { connect } from "react-redux";
import { debounce } from "../../helpers/debounce";
import ContentLoader from "react-content-loader";

const Explore = ({ searchRestaurants, clearSearch, restaurants }) => {
    const [queryLengthError, setQueryLengthError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showBgImage, setShowBgImage] = useState(true);
    const [nothingFound, setNothingFound] = useState(false);

    const navigate = useNavigate();

    const handleRestaurantSearch = debounce((query) => {
        if (query.length >= 3) {
            const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
            searchRestaurants(userSetAddress.lat, userSetAddress.lng, query);
            setQueryLengthError(false);
            setLoading(true);
            setNothingFound(false);
        } else {
            setQueryLengthError(true);
        }
    }, 400);

    useEffect(() => {
        const exploreLink = document.querySelector("a[href='/explore']");
        if (exploreLink) {
            exploreLink.classList.add("no-click");
        }

        return () => {
            if (exploreLink) {
                exploreLink.classList.remove("no-click");
            }
            clearSearch();
        };
    }, [clearSearch]);

    useEffect(() => {
        if (restaurants) {
            setLoading(false);
            if (restaurants.restaurants?.length === 0 && restaurants.items?.length === 0) {
                setShowBgImage(true);
                setNothingFound(true);
            } else {
                setShowBgImage(false);
                setNothingFound(false);
            }
        }
    }, [restaurants]);

    if (window.innerWidth > 768) {
        return <Navigate to="/" />;
    }
    if (localStorage.getItem("storeColor") === null) {
        return <Navigate to="/" />;
    }

    return (
        <React.Fragment>
            <Meta
                seotitle={localStorage.getItem("seoMetaTitle")}
                seodescription={localStorage.getItem("seoMetaDescription")}
                ogtype="website"
                ogtitle={localStorage.getItem("seoOgTitle")}
                ogdescription={localStorage.getItem("seoOgDescription")}
                ogurl={window.location.href}
                twittertitle={localStorage.getItem("seoTwitterTitle")}
                twitterdescription={localStorage.getItem("seoTwitterDescription")}
            />
            {queryLengthError && (
                <div className="auth-error" style={{ marginBottom: "4rem" }}>
                    <div>{localStorage.getItem("searchAtleastThreeCharsMsg")}</div>
                </div>
            )}
            <RestaurantSearch searchFunction={handleRestaurantSearch} />

            {loading && (
                <ContentLoader
                    height={window.innerHeight}
                    width={window.innerWidth}
                    speed={1.2}
                    primarycolor="#f3f3f3"
                    secondarycolor="#ecebeb"
                >
                    <rect x="20" y="20" rx="4" ry="4" width="80" height="78" />
                    <rect x="144" y="35" rx="0" ry="0" width="115" height="18" />
                    <rect x="144" y="65" rx="0" ry="0" width="165" height="16" />
                    {/* Add more rectangles as needed */}
                </ContentLoader>
            )}

            {restaurants.restaurants?.length > 0 && (
                <RestaurantSearchList restaurants={restaurants.restaurants} />
            )}
            {restaurants.items?.length > 0 && (
                <ItemSearchList items={restaurants.items} />
            )}

            {showBgImage && (
                <div className="d-flex justify-content-center mt-100">
                    <img
                        className="img-fluid explore-bg"
                        src="/assets/img/various/explore-bg.png"
                        alt={localStorage.getItem("restaurantSearchPlaceholder")}
                    />
                </div>
            )}
            {nothingFound && (
                <div className="auth-error" style={{ marginBottom: "4rem" }}>
                    <div className="error-shake">{localStorage.getItem("exploreNoResults")}</div>
                </div>
            )}

        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    restaurants: state.restaurants.restaurants,
});

export default connect(mapStateToProps, { searchRestaurants, clearSearch })(Explore);
